import React from "react";
import { Row, Col } from "react-bootstrap";
import Img from "gatsby-image";
import Theme from "../../vars/ThemeOptions";
import { Button } from "./";
import styled from "styled-components";
import get from "lodash/get";
import { rejig2020Title } from "../modules";

const Styled = {};
Styled.ImageOffset = styled(Row)`
  padding-bottom: 8vh;
  width: 100%;
  margin: 0;
  overflow: hidden;
  & > div {
    padding: 0;
    position: relative;
    .gatsby-image-wrapper {
      height: 60vh;
      max-height: 520px;
      max-width: 100vw;
    }
  }
  .cta {
    position: absolute;
    height: 100%;
    top: 0%;
    left: 50%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .plate {
      background: ${Theme.hex("concrete")};
      padding: 4vh 3vh;
      border-left: 5px solid ${Theme.hex("green")};
      box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.25);
      h5 {
        text-align: center;
      }
    }
    @media screen and (max-width: ${Theme.break.sm}px) {
      top: initial;
      bottom: initial;
      right: initial;
      left: initial;
      top: 25%;
    }
  }
`;

export const ImageOffset = ({ fixed, alt, nameplate, cta }) => {
  return (
    <Styled.ImageOffset>
      <Col xs={12} sm={12} md={11} lg={10}>
        {fixed && <Img fixed={fixed} alt={alt} />}
        {nameplate || cta ? (
          <div className="cta">
            <Row className="flex-column">
              <div className="plate">
                {nameplate ? (
                  <>
                    <h4>{rejig2020Title(get(nameplate, `header`))}</h4>
                    <h5>{get(nameplate, `subtitle`)}</h5>
                  </>
                ) : null}
                {cta ? (
                  <>
                    <h5>
                      {rejig2020Title(cta.title)}
                      <br />
                      2020 Performance
                    </h5>
                    <Button to={get(cta, `pdf.file.url`)} target="_blank">
                      Download
                    </Button>
                  </>
                ) : null}
              </div>
            </Row>
          </div>
        ) : null}
      </Col>
    </Styled.ImageOffset>
  );
};
